import calendarComponent from './calendar.component';

import 'jquery';
import 'bootstrap-datepicker-extended';
import 'bootstrap-datepicker-extended/dist/locales/bootstrap-datepicker.es.min.js';

let calendarModule = angular.module('vacations-absences.calendar', [])

.component('calendar', calendarComponent)

.name;

export default calendarModule;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/calendar/calendar.js